export default function Question() {
    return (
        <div className="flex items-center justify-center bg-[#43385E] w-[284px] h-[284px] md:w-[530px] md:h-[530px] shadow-black rounded-[6px] inset-0 -z-[9999]" style={{ boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)' }}>
            <img
                src="./assets/icons/interrogacao.png"
                alt="hashguys question mark"
                className=" p-0 m-0 block w-[280px] h-[280px] md:w-[520px] md:h-[520px]"
            />
        </div>
    );
}